import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { authService } from '../services/authService';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { currentUser } = useAuth();

  useEffect(() => {
    if (currentUser) {
      navigate('/');
    }
  }, [currentUser, navigate]);

  const handleGoogleLogin = async () => {
    setError('');
    setLoading(true);
    const result = await authService.loginWithGoogle();
    if (result.success) {
      navigate('/');
    } else {
      setError(result.error || 'Error al iniciar sesión con Google');
    }
    setLoading(false);
  };

  const handleEmailLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const result = await authService.loginWithEmail(email, password);
    if (result.success) {
      navigate('/');
    } else {
      setError(result.error || 'Error al iniciar sesión. Verifica tus credenciales.');
    }
    setLoading(false);
  };

  return (
    <div className="mobile-login-wrapper">
      <div className="login-backdrop-glow"></div>
      <div className="login-card-modern">
        {/* Brand Header */}
        <div className="login-brand">
          <div className="brand-logo-circle">
            <img src="/app-icon.png" alt="Comarsa" style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }} />
          </div>
          <h1 className="brand-title">Comarsa App</h1>
          <p className="brand-subtitle">Control de Asistencia Biométrico</p>
        </div>

        {/* Formulario */}
        <form onSubmit={handleEmailLogin} className="login-form-modern">
          <div className="input-field-group">
            <label className="input-label">Correo electrónico</label>
            <div className="input-with-icon">
              <i className="fa-solid fa-envelope input-icon"></i>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="colaborador@comarsa.com"
                className="input-modern"
              />
            </div>
          </div>

          <div className="input-field-group">
            <label className="input-label">Contraseña</label>
            <div className="input-with-icon">
              <i className="fa-solid fa-lock input-icon"></i>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="••••••••"
                className="input-modern"
              />
            </div>
          </div>

          {error && (
            <div className="login-error-alert">
              <i className="fa-solid fa-circle-exclamation"></i>
              <span>{error}</span>
            </div>
          )}

          <button type="submit" className="btn-login-primary" disabled={loading}>
            {loading ? (
              <>
                <i className="fa-solid fa-circle-notch fa-spin"></i>
                <span>Iniciando sesión...</span>
              </>
            ) : (
              <>
                <span>Iniciar Sesión</span>
                <i className="fa-solid fa-arrow-right"></i>
              </>
            )}
          </button>
        </form>

        <div className="divider-modern">
          <span>O continúa con</span>
        </div>

        <button 
          type="button"
          onClick={handleGoogleLogin} 
          className="btn-google-modern"
          disabled={loading}
        >
          <img 
            src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" 
            alt="Google" 
            className="google-svg-icon"
          />
          <span>Cuenta Google</span>
        </button>

        <div className="login-footer-info">
          <span>Sistema Seguro v1.2 • Grupo Comarsa</span>
        </div>
      </div>
    </div>
  );
};

export default Login;